import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import TopBar from './TopBar';
import Sidebar from './Sidebar';
import Container from '@mui/material/Container';

const drawerWidth = 260;

export default function AppLayout({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const toggle = () => setMobileOpen(!mobileOpen);

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <TopBar onMenuClick={toggle} />
      <Sidebar mobileOpen={mobileOpen} onClose={toggle} drawerWidth={drawerWidth} />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          // empurra conteúdo quando: md+ (sempre) e xs (se menu aberto)
          ml: { xs: mobileOpen ? `${drawerWidth}px` : 0, md: `${drawerWidth}px` },
          width: {
            xs: mobileOpen ? `calc(100% - ${drawerWidth}px)` : '100%',
            md: `calc(100% - ${drawerWidth}px)`,
          },
        }}
      >
        <Toolbar />
        <Container maxWidth="lg">{children}</Container>
      </Box>
    </Box>
  );
}
